import type { MutableRefObject } from 'react';
import { useRef } from 'react';

export const usePushSubscriptionRef = (): MutableRefObject<PushSubscription | null | undefined> =>
  useRef<PushSubscription | null | undefined>();
